import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import axios from "axios";
import useApiNew from "../../../utils/useApiNew";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDate from "./date/CustomDate";
import CustomDate1 from "./date/CustomDate1";
import CustomDate2 from "./date/CustomDate2";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";
import SearchableSecondaryScriptDropdown from "../../../components/corporateAction/corpMaster/dropDowns/SearchableSecondaryScriptDropdown";

const scriptApiURL = `${process.env.REACT_APP_API_URL}api/script`;
const securityTypeURLApi = `${process.env.REACT_APP_API_URL}api/security-type`;

const CorporateActionMasterEdit = ({
  buttonConfig,
  renderKey,
  selectedItemId,
  rowData,
  userID,
  rejectedId,
  isButtonClicked,
}) => {
  const editHandler = buttonConfig.editHandler;
  const getDataForEdit = rowData;

  const closeHandler = buttonConfig.closeEditModal;
  const [HandleSetValue, setHandleSetValue] = useState("");
  const [handleInput, setHandleInput] = useState({});
  const [isin, setIsin] = useState("");
  const [securityType, setSecurityType] = useState("");
  const [faceValue, setFaceValue] = useState("");
  const [scriptName, setScriptName] = useState("");
  const [secIsin, setSecIsin] = useState("");
  const [secSecurityType, setSecSecurityType] = useState("");
  const [secFaceValue, setSecFaceValue] = useState("");
  const [secScriptName, setSecScriptName] = useState("");
  const [handleInputChange, setHandleInputChange] = useState({});
  const [secondaryData, setSecondaryData] = useState();

  const autoFillData = {
    action_code: "M",
    isin: isin,
    security_type: secSecurityType ? secSecurityType : securityType,
    face_value: secFaceValue ? secFaceValue : faceValue,
    script_name: scriptName,
  };

  const autoFillData1 = {
    isin_sec: secIsin,
  };

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
      "Content-Type": "application/json",
    }),
    [],
  );

  const { data: scriptData } = useApiNew(scriptApiURL, "GET", { headers });

  const { data: securityData } = useApiNew(securityTypeURLApi, "GET", {
    headers,
  });
  // sec_scrip_id
  // update_leftover_sec
  const schema = z.object({
    file_tag: z.string(),
    action_code: z.string(),
    sec_scrip_id: z.number().optional(),
    inputile_id: z.string(),
    isin: z.string(),

    status: z.string(),
    isin_sec: z.string().optional(),
    // bookclose_recorddate: z.string(),
    // bse_exdate: z.string(),
    // nse_exdate: z.string(),
    corpaction_tag: z.string(),
    price: z.string().optional().optional(),
    multiplier: z.string().optional(),
    company_name: z.string().optional(),
    security_type: z.string().optional(),
    face_value: z.string().optional(),
    remarks: z.string().optional(),
    caa_status: z.string(),
  });
  console.log("getDataForEdit:::", getDataForEdit);

  const form = useForm({
    defaultValues: {
      status: getDataForEdit?.status,
      file_tag: getDataForEdit.file_tag,
      action_code: getDataForEdit.action_code,
      inputile_id: getDataForEdit.inputile_id,
      isin: getDataForEdit.isin,
      isin_sec:
        getDataForEdit.isin_sec === null || getDataForEdit.isin_sec === "nan"
          ? ""
          : getDataForEdit.isin_sec,
      bookclose_recorddate: getDataForEdit.bookclose_recorddate,
      bse_exdate: getDataForEdit.bse_exdate,
      nse_exdate: getDataForEdit.nse_exdate,
      corpaction_tag: getDataForEdit.corpaction_tag,
      price:
        getDataForEdit.price === null || getDataForEdit.price === "nan"
          ? ""
          : getDataForEdit.price,
      multiplier:
        getDataForEdit.multiplier === null ||
        getDataForEdit.multiplier === "nan"
          ? ""
          : getDataForEdit.multiplier,
      script_name: getDataForEdit?.script_name?.split("_")[0],
      security_type: getDataForEdit.security_type || "",
      face_value:
        getDataForEdit.face_value === null ||
        getDataForEdit.face_value === "nan"
          ? ""
          : getDataForEdit.face_value,
      remarks: getDataForEdit.remarks,
      caa_status: getDataForEdit.caa_status,
      sec_scrip_id:
        getDataForEdit.sec_scrip_id === null ||
        getDataForEdit.sec_scrip_id === "nan"
          ? ""
          : getDataForEdit.sec_scrip_id,
      secondary_security_type:
        getDataForEdit.secondary_security_type === null ||
        getDataForEdit.secondary_security_type === "nan"
          ? ""
          : getDataForEdit.secondary_security_type,
      secondary_face_value:
        getDataForEdit.secondary_face_value === null ||
        getDataForEdit.secondary_face_value === "nan"
          ? ""
          : getDataForEdit.secondary_face_value,
      company_name:
        getDataForEdit.company_name === null ||
        getDataForEdit.company_name === "nan"
          ? ""
          : getDataForEdit.company_name,
    },
    resolver: zodResolver(schema),
  });

  const handleChange = (e) => {
    setHandleInput((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const objdata = {
    status: handleInput.status,
    file_tag: "VSFT",
    ...handleInput,
    ...HandleSetValue,
    ...autoFillData,
    ...autoFillData1,
  };

  useEffect(() => {
    setHandleInputChange({
      status: handleInput.status,
      file_tag: "VSFT",
      ...handleInput,
      ...HandleSetValue,
      ...autoFillData,
      ...autoFillData1,
    });
  }, [handleInput, HandleSetValue]);

  const handleOnSelect1 = (e) => {
    const [scrt, isin, securityType, faceValue, id] = e.target.value.split("_");
    setSecIsin(isin);
    setSecSecurityType(securityType);
    setSecFaceValue(faceValue);
    setSecScriptName(scrt);
    form.setValue("isin_sec", isin !== "nan" ? isin : "");
    form.setValue("secondary_security_type", securityType);
    form.setValue("secondary_face_value", faceValue);
    form.setValue("secondary_company_name", scrt);
    // form.setValue("company_name", scrt);
    form.setValue("sec_scrip_id", Number(id));
  };

  const onSubmit = async (data) => {
    objdata.corpaction_tag = form.getValues("corpaction_tag");
    const updatedData = {
      ...objdata,
      ...data,
      script_name: form.getValues("script_name"),

      updated_by: userID,
      bookclose_recorddate: HandleSetValue?.bookclose_recorddate
        ? HandleSetValue?.bookclose_recorddate
        : form.getValues("bookclose_recorddate"),
      bse_exdate: HandleSetValue?.bse_exdate
        ? HandleSetValue?.bse_exdate
        : form.getValues("bse_exdate"),
      nse_exdate: HandleSetValue?.nse_exdate
        ? HandleSetValue?.nse_exdate
        : form.getValues("nse_exdate"),
      id: getDataForEdit?.id,
      sec_scrip_id:
        form.getValues("sec_scrip_id") &&
        Number(form.getValues("sec_scrip_id")),
      isin_sec: form.getValues("isin_sec"),
      secondary_security_type: form.getValues("secondary_security_type") || "",
      secondary_face_value: form.getValues("secondary_face_value") || "",
      secondary_company_name: form.getValues("secondary_company_name") || "",
      company_name: form.getValues("company_name").split("_")[0] || "",
      rejected: form.getValues("caa_status") === "A" ? rejectedId : [],
      update_leftover_sec: form.getValues("sec_scrip_id") ? rejectedId : [],
    };
    const res = await editHandler(selectedItemId, updatedData);
    if (res) closeHandler();
  };

  useEffect(() => {
    if (scriptData) {
      const filterData = scriptData?.filter(
        (item) => item.script_name === getDataForEdit.company_name,
      );
      setSecondaryData(filterData[0]);
      form.setValue("secondary_security_type", filterData[0]?.script_type_name);
      form.setValue("isin_sec", filterData[0]?.isin);
      form.setValue(
        "secondary_face_value",
        filterData[0]?.nse_face_value
          ? filterData[0]?.nse_face_value
          : filterData[0]?.bse_face_value,
      );
    }
  }, [getDataForEdit, scriptData]);
  const onClose = () => {
    closeHandler();
  };

  let a = {
    B: "Bonus",
    S: "Split",
    R: "Reduction",
    C: "Consolidation",
    A: "Merger",
    X: "Demerger",
    D: "Dividend",
    G: "Rights",
  };
  console.log("FORM:::", form.getValues());

  return (
    <>
      <div className="fixed left-1/2 top-[57%] z-50 mx-auto w-[98%] max-w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8 max-lg:max-h-[800px] lg:max-h-[600px]">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Edit Corporate Action{" "}
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="scrollbar-custom w-full overflow-y-scroll pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="w-full items-baseline gap-2 lg:flex ">
              <div className="w-full items-baseline gap-2 sm:flex ">
                <div
                  className={
                    " flex w-full flex-col items-stretch gap-2 text-neutral-600"
                  }
                >
                  <label className="block text-base text-[#636363]">
                    Scrip name
                  </label>

                  <input
                    disabled
                    {...form.register("script_name")}
                    name="script_name"
                    className={
                      "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                    }
                  />
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>ISIN</label>

                    <div className="relative flex w-full">
                      <input
                        disabled
                        onChange={handleChange}
                        placeholder="Enter here"
                        {...form.register("isin")}
                        // value={getDataForEdit.isin}
                        name="isin"
                        className={
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full items-baseline gap-2 max-lg:mt-4 sm:flex">
                <div className={"flex w-full flex-col gap-2"}>
                  <label className="text-base text-[#636363]">
                    Corporate Action
                  </label>
                  <select
                    onChange={handleChange}
                    name="corpaction_tag"
                    {...form.register("corpaction_tag")}
                    // value={getDataForEdit.corpaction_tag}
                    className={
                      "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                    }
                  >
                    <option
                      className=""
                      defaultValue={getDataForEdit.corpaction_tag}
                    >
                      {a[getDataForEdit.corpaction_tag]}
                    </option>
                    <option value="B" className="">
                      Bonus
                    </option>
                    <option value="S" className="">
                      Split
                    </option>
                    <option value="R" className="">
                      Reduction
                    </option>
                    <option value="C" className="">
                      Consolidation
                    </option>
                    <option value="A" className="">
                      Merger
                    </option>
                    <option value="X" className="">
                      Demerger
                    </option>
                    <option value="D" className="">
                      Dividend
                    </option>
                    <option value="G" className="">
                      Rights
                    </option>
                  </select>
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Corp. Action Status</label>
                    <select
                      onChange={handleChange}
                      name="caa_status"
                      {...form.register("caa_status")}
                      defaultValue="P"
                      className={
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                      }
                    >
                      <option value="P">Pending</option>
                      <option value="A">Approved</option>
                      <option value="R">Rejected</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>BC Record Date</label>

                    <div className="relative flex w-full">
                      <CustomDate
                        setHandleSetValue={setHandleSetValue}
                        initialValue={getDataForEdit.bookclose_recorddate}
                      />
                    </div>
                  </div>
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>NSE EX Date</label>

                    <div className="relative flex w-full">
                      <CustomDate1
                        setHandleSetValue={setHandleSetValue}
                        initialValue={getDataForEdit.nse_exdate}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>BSE Ex Date</label>

                    <div className="relative flex w-full">
                      <CustomDate2
                        setHandleSetValue={setHandleSetValue}
                        initialValue={getDataForEdit.bse_exdate}
                      />
                    </div>
                  </div>
                </div>
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Dividend / Rights Price</label>

                    <div className="relative flex w-full">
                      <input
                        onChange={handleChange}
                        {...form.register("price")}
                        placeholder="Enter here"
                        className={
                          "h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* row 3 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 sm:flex ">
                <div className={"flex w-full flex-col  gap-2"}>
                  <label className="text-base text-[#636363]">Multiplier</label>
                  <input
                    onChange={handleChange}
                    // value={getDataForEdit.multiplier}
                    name="multiplier"
                    {...form.register("multiplier")}
                    placeholder="Enter here"
                    className={
                      "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                    }
                  />
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Security Type</label>
                    <select
                      name="security_type"
                      onChange={handleChange}
                      defaultValue={form.getValues("security_type")}
                      className={
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                      }
                    >
                      <option value={null}>Select</option>
                      {securityData &&
                        securityData.map((item, index) => (
                          <option value={`${item?.short_name}`} key={index}>
                            {item?.security_type}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Face Value</label>

                    <div className="relative flex w-full">
                      <input
                        onChange={handleChange}
                        placeholder="Enter here"
                        name="face_value"
                        // value={getDataForEdit.face_value}
                        {...form.register("face_value")}
                        className={
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Status</label>
                    <select
                      onChange={handleChange}
                      defaultValue={form.getValues("status")}
                      name="status"
                      // {...form.register("status")}
                      className={
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                        // errors.security_code && "border-[1px] border-red-300",
                      }
                    >
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* row 4 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 sm:flex  ">
                <div
                  className={
                    "flex w-full flex-col items-stretch gap-2 text-neutral-600"
                  }
                >
                  <label className="">Secondary Scrip Name</label>
                  <SearchableSecondaryScriptDropdown
                    form={form}
                    scriptData={scriptData}
                    handleOnSelect1={handleOnSelect1}
                    handleInput={handleInput}
                    getDataForEdit={getDataForEdit}
                    className="w-full"
                  />
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Secondary ISIN</label>

                    <div className="relative flex w-full">
                      <input
                        placeholder="Enter here"
                        {...form.register("isin_sec")}
                        disabled={["B", "S", "C", "D", "G"].includes(
                          handleInput.corpaction_tag,
                        )}
                        name="isin_sec"
                        className={
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex  ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Secondary Security Type</label>
                    <input
                      name="secondary_security_type"
                      placeholder="Enter here"
                      // value={secSecurityType}
                      {...form.register("secondary_security_type")}
                      // disabled={["B", "S", "C", "D", "G"].includes(
                      //   handleInput.corpaction_tag,
                      // )}
                      className={
                        "h-full rounded bg-neutral-100 px-2 py-[.7rem] text-[#636363] placeholder:italic focus:outline-none"
                      }
                    />
                  </div>
                </div>
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Secondary Face Value</label>

                    <div className="relative flex w-full">
                      <input
                        // disabled={["B", "S", "C", "D", "G"].includes(
                        //   handleInput.corpaction_tag,
                        // )}
                        // value={secFaceValue}
                        {...form.register("secondary_face_value")}
                        placeholder="Enter here"
                        name="secondary_face_value"
                        className={
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100  px-2 py-[.7rem] text-[#636363] focus:outline-none"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-neutral-600 max-sm:mt-4">
              <label>Remarks</label>
              <textarea
                onChange={handleChange}
                {...form.register("remarks")}
                rows={3}
                cols={50}
                className=" w-full rounded-[5px] bg-neutral-100 p-2 text-[#636363]"
              />
            </div>
          </div>

          <div className="mt-8 flex items-end max-sm:justify-center md:justify-between max-lg:[&>button]:w-[50%] max-sm:[&>button]:w-full lg:[&>button]:w-1/4">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={`${
                isButtonClicked ? "opacity-[70%]" : ""
              }  w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-7 py-2 font-semibold text-white`}
            >
              {isButtonClicked ? <MirageLoader /> : "SAVE CHANGES"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
            <button className="max-md:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default CorporateActionMasterEdit;
